// Saved filters = a localStorage-backed "save this search" feature so users
// can recall a filter set ("My books search", "Cheap furniture nearby") with
// one click. Notification-based saved searches are a separate epic — this
// solves the recall UX today without backend.

const STORAGE_KEY = 'flea:savedFilters';
const MAX_SAVED = 5;

const safeParse = (raw) => {
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export function getSavedFilters() {
  if (typeof window === 'undefined') return [];
  return safeParse(window.localStorage.getItem(STORAGE_KEY));
}

export function saveFilter(name, filters) {
  if (typeof window === 'undefined' || !name) return;
  const trimmed = name.trim().slice(0, 40);
  if (!trimmed) return;
  const entry = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    name: trimmed,
    filters,
    saved_at: Date.now(),
  };
  const existing = getSavedFilters().filter((f) => f.name !== trimmed);
  const next = [entry, ...existing].slice(0, MAX_SAVED);
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
}

export function deleteSavedFilter(id) {
  if (typeof window === 'undefined' || !id) return;
  const next = getSavedFilters().filter((f) => f.id !== id);
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
}

export function isFilterMeaningful(filters) {
  // Don't let users save an "empty" search.
  return Object.entries(filters || {}).some(
    ([key, value]) => key !== 'view' && value !== '' && value !== undefined && value !== null,
  );
}
